import { Component, Input, ViewEncapsulation } from '@angular/core';

/**
 *
 * A simple component that renders the New Visions logo as an `svg`.
 *
 * Use this wherever you need to use the logo.
 *
 * Resize this as you need by modifying the `height` property.
 */
@Component({
  selector: 'nv-logo',
  templateUrl: './nv-logo.component.html',
  styleUrls: ['./nv-logo.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NvLogoComponent {
  @Input() type: 'symbol' | 'symbol-invert' | 'wordmark' | 'portal' | 'family-portal-logo' | 'family-portal-logo-symbol-white-no-text' | 'ecfik-large-blue-symbol' | 'ecfik-large-white-symbol' | 'ecfik-small-blue-symbol' | 'ecfik-small-white-symbol';
  @Input() pointerOnHover: boolean = false;
}
